module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.12413cac.ttf";